/**
 * Lightweight logger: emits to console only in non-production builds.
 * Errors are always emitted so production issues can still be diagnosed.
 */

const isDev = process.env.NODE_ENV !== 'production';

export const logger = {
  log: (...args) => { if (isDev) console.log(...args); },
  warn: (...args) => { if (isDev) console.warn(...args); },
  info: (...args) => { if (isDev) console.info(...args); },
  debug: (...args) => { if (isDev) console.debug(...args); },
  // Errors are always logged so we don't lose production diagnostics.
  error: (...args) => { console.error(...args); },
};

export default logger;
